export default __webpack_public_path__ + "dist/media/MinusDarkBlue.897c1234.svg";